/**
 *  Error handler to be hooked on each Vue application that will forward the error to TrackJS.
 *
 *  Documentation references:
 *    - https://docs.trackjs.com/browser-agent/integrations/vue/
 *    - https://vuejs.org/api/application#app-config-errorhandler
 *
 * @param {Error}  err - provided by Vue API
 * @param {Object} instance - provided by Vue API
 * @param {string} info - provided by Vue API
 */
const vueToTrackJsErrorHandler = (err, instance, info) => {
  // Emit component name and also the lifecycle hook the error occurred in if present
  var infoMessage = `Error in component: <${instance.$options.name} />\n`;
  if (info) {
    infoMessage += `Error occurred during lifecycle hook: ${info}\n`;
  }

  // Log properties passed to the component if there are any
  if (instance.$options.propsData) {
    infoMessage += `Props passed to component: ${instance.$options.propsData}`;
  }

  // This puts the additional error information in the Telemetry Timeline on the Dashboard
  // Do not change to error as it will duplicate the error in the Telemetry Timeline on the Dashboard
  // Do not replace with a logging lib like Datadog, this is a special case for TrackJS
  console.warn(infoMessage);

  // Track the native JS error, this is the main error message on the Dashboard
  window?.TrackJS?.track(err);
};

export { vueToTrackJsErrorHandler };
